import { colorForIndex, CRITERION_COLORS } from "./report-card/reportCardModel";

/**
 * A persona's identifying colour, derived from its position in the cast.
 *
 * There is no stored colour field. The hue comes from the same seven tones the
 * report card uses for criteria, and carries the same rule: HUE SAYS WHICH,
 * NEVER HOW GOOD. On the report card it identifies a criterion; here it
 * identifies a persona. Teal stays reserved for system affordances.
 *
 * Position is only meaningful because the server orders the personas relation
 * by created_at — see loadScenario in scenarios.service.ts. Without that
 * ordering these hues shuffle between requests.
 */
export function personaHueByIndex(index: number): string {
  if (!Number.isInteger(index) || index < 0) return CRITERION_COLORS[0];
  return colorForIndex(index);
}

/**
 * The hue for one persona, resolved through the cast it belongs to. Returns
 * the first tone rather than undefined for an id that is not in the cast, so
 * a caller never has to guard a colour.
 */
export function personaHue(
  personas: readonly { id: string }[],
  personaId: string,
): string {
  const index = personas.findIndex((p) => p.id === personaId);
  return personaHueByIndex(index);
}
